/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowPaintballGameTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowPaintballGame,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Get Ready for Battle!",
    "Paintball Adventure Awaits!",
    "Let’s Play!",
  ],
  title: "Paintball Game",
  description: "Organize an exhilarating paintball game.",
  longDescription:
    "Gather your friends for an action-packed paintball game! Choose a date, select a paintball location, and plan refreshments for afterward!",
  emoji: "🔫",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Paintball Game",
          emoji: "🔫",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the paintball game?",
          emoji: "📅",
          completeAction: {
            question: "Decide on a paintball location?",
            description: "Where do we want to play paintball?",
            addModules: [
              {
                type: ModuleType.Location,
                doneType: ModuleDoneType.Voting,
                title: "What location should we choose?",
                emoji: "🌳",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we have after the game?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍕",
                    },
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What drinks should we serve?",
                      emoji: "🥤",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Get Ready for Action!",
    outroDescription: "Your paintball game plans are set! Enjoy the adventure!",
  },
};
